<template>
  <div>
    <template v-if="listing.description">
      <h3 class="text-xl font-medium">{{ $t('titles.description') }}</h3>

      <p class="mb-4 mt-2 whitespace-pre-wrap">{{ listing.description }}</p>
    </template>

    <div v-if="listingIs.wanted && listing.movement.radius <= 200" class="mb-4">
      Wanted within {{ listing.movement.radius }} miles of {{ listing.location[0].region }}
    </div>

    <ListingDetailsLivestock
      v-if="listingIs.livestock"
      :listing="listing"
      :listingIs="listingIs"
      :isLoading="isLoading"
    />

    <ListingDetailsFeedBedding
      v-if="listingIs.feedBedding"
      :listing="listing"
      :listingIs="listingIs"
      :isLoading="isLoading"
    />

    <ListingDetailsWorkingDogs
      v-if="listingIs.workingDogs && listingIs.forSale"
      :listing="listing"
      :listingIs="listingIs"
      :isLoading="isLoading"
    />

    <div
      v-if="(compMetaTags.length || compAge || listing.meta.farmAssured) && !listingIs.workingDogs"
      class="mt-6"
    >
      <UtilDivider class="mt-5 mb-3" />

      <h3 class="text-xl font-medium">{{ $t('titles.keyDetails') }}</h3>

      <div class="mt-4">
        <span v-if="compAge" class="block mb-2">
          <FontAwesomeIcon :icon="faCalendarAlt" fixedWidth class="mr-1" />
          {{ compAge }} old
        </span>

        <span v-if="listing.meta.farmAssured" class="block relative w-6/12 md:w-full lg:w-6/12">
          <FontAwesomeIcon :icon="faCheckCircle" fixedWidth class="mr-1 text-brand" />
          Farm Assured
          <span
            v-if="!listingIs.redTractorVerified && listingIs.inEngland"
            class="block ml-8 text-gray-lighter uppercase leading-tight text-sm mb-1"
          >
            Unverified
          </span>
        </span>

        <span v-for="tag in compMetaTags" :key="tag" class="block mb-2">
          <FontAwesomeIcon :icon="faCheckCircle" fixedWidth class="mr-1 text-brand" />
          <span>{{ tag }}</span>
          <span
            v-if="listing.meta.organicAssured && tag === 'Organic'"
            class="block ml-8 text-gray-lighter uppercase leading-tight text-sm mb-1"
          >
            Unverified
          </span>
        </span>
      </div>

      <UtilListingRedTractorAssured v-if="listingIs.redTractorVerified" :listing="listing" class="mt-6" />
    </div>
  </div>
</template>

<script>
import { faCheckCircle, faCalendarAlt } from '@fortawesome/pro-regular-svg-icons'
import getLivestockAge from '@/lib/helpers/livestock-age'
import ListingDetailsLivestock from '@/views/ListingDetailsLivestock'
import ListingDetailsFeedBedding from '@/views/ListingDetailsFeedBedding'
import ListingDetailsWorkingDogs from '@/views/ListingDetailsWorkingDogs'
import UtilDivider from '@/components/utils/UtilDivider'
import UtilListingRedTractorAssured from '@/components/utils/listing/UtilListingRedTractorAssured'

export default {
  name: 'ListingDetails',
  components: {
    ListingDetailsLivestock,
    ListingDetailsFeedBedding,
    ListingDetailsWorkingDogs,
    UtilDivider,
    UtilListingRedTractorAssured
  },
  props: {
    isLoading: Boolean,
    listing: {
      type: Object,
      required: true
    },
    listingIs: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      faCheckCircle,
      faCalendarAlt
    }
  },
  computed: {
    compMetaTags() {
      return this.$store.getters['listing/overviewMetaTags'](this.listing)
    },

    compAge() {
      if (!this.listingIs.livestock) {
        return ''
      }

      return getLivestockAge(this.listing)
    }
  }
}
</script>
